import i18n from '../../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../../core/components/input-widget/BaseModel";

export default class AuctionClerkModel extends BaseModel {
  clerk = null;

  static TRANSLATABLE_FIELDS = [];

  rules = {};

  attributeLabels = {
    clerk: i18n.t('Clerk'),
  };

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
    this.initTranslatableFields(this);
  }
}

defineTranslatableProperties(AuctionClerkModel);
